import { LitElement, html } from "lit";
import { customElement } from "lit/decorators.js";
import { API_URL } from "../api/client.js";
import { externalLinkIcon } from "../utils/format.js";

@customElement("app-footer")
export class AppFooter extends LitElement {
  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <footer class="border-t border-hb-border mt-12 py-6">
        <div class="max-w-7xl mx-auto px-4 flex flex-wrap items-center justify-between gap-4 text-sm text-gray-500">
          <span>Hummingbird Image Catalog</span>
          <div class="flex gap-4">
            ${API_URL
              ? html`<a href="${API_URL}/v1/docs/" target="_blank" class="hover:text-gray-300 transition-colors"
                  >API Docs${externalLinkIcon}</a
                >`
              : ""}
            <a
              href="https://gitlab.com/redhat/hummingbird/tools/-/tree/main/container-catalog"
              target="_blank"
              class="hover:text-gray-300 transition-colors"
              >Source${externalLinkIcon}</a
            >
          </div>
        </div>
      </footer>
    `;
  }
}
